export const routeConstants = {
  // Public authentication routes
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',

  // Authenticated user role selection
  ROLE_SELECTION: '/role-selection',

  // Dashboard
  DASHBOARD: '/dashboard',

  // Students
  STUDENTS: '/students',
  ADD_STUDENT: '/students/add',
  EDIT_STUDENT: '/students/:id/edit',
  STUDENT_DETAILS: '/students/:id',

  // Staff
  STAFF: '/staff',
  ADD_STAFF: '/staff/add',
  EDIT_STAFF: '/staff/:id/edit',
  STAFF_DETAILS: '/staff/view/:id',

  // Fees
  FEES_MANAGEMENT: '/fees/management',
  FEES_STRUCTURE: '/fees/structure',
  FEES_COLLECTION: '/fees/collection',
  FEES_HISTORY: '/fees/history',

  // Documents and ID cards
  DOCUMENTS_ID_CARDS: '/documents/id-cards',
  DOCUMENTS_TEMPLATES: '/documents/templates',
  DOCUMENTS_JOBS: '/documents/generation-jobs',
  DOCUMENTS_HISTORY: '/documents/card-history',

  // Academics
  ACADEMICS_TIMETABLE: '/academics/timetable',

  // Settings
  SETTINGS: '/settings',
  SETTINGS_PROFILE: '/settings/profile',
  SETTINGS_BRANDING: '/settings/branding',
  SETTINGS_ACADEMICS: '/settings/academics',
  SETTINGS_USERS: '/settings/users',
  SETTINGS_ROLES: '/settings/roles',
};